import { publicAssetUrl } from './assetUrl'

type ListingImage = {
  is_primary?: boolean
  thumbnail_url?: string
  display_url?: string
}

type ListingLike = {
  images?: ListingImage[]
  phone_model: {
    manufacturer: string
    model_name: string
    hero_image_path?: string | null
  }
}

/** All seller photo URLs for catalog card swipe (display preferred over thumbnail). */
export function listingCardPhotoUrls(listing: ListingLike): { urls: string[]; isUserPhoto: boolean } {
  const images = listing.images
  if (!images?.length) return { urls: [], isUserPhoto: false }
  const urls = images
    .map((i) => {
      const path = i.display_url || i.thumbnail_url
      return path ? publicAssetUrl(path) : null
    })
    .filter((u): u is string => Boolean(u))
  return { urls, isUserPhoto: urls.length > 0 }
}

/** Seller-uploaded photo only; null when the listing has no user images. */
export function listingCardThumb(listing: ListingLike): { src: string | null; isUserPhoto: boolean } {
  const images = listing.images
  if (images?.length) {
    const primary = images.find((i) => i.is_primary) ?? images[0]
    const path = primary.display_url || primary.thumbnail_url
    if (path) {
      return { src: publicAssetUrl(path), isUserPhoto: true }
    }
  }
  return { src: null, isUserPhoto: false }
}
